export class ShoppingCartDiscount {
  id: string;
  productCode: string;
  discountValue: number;
  ean: string;
  saleCoefficient: number;
  isDefault: boolean;
  validityStartDate: Date;
  validityEndDate: Date;
}
